const init = () => {
	if($('.autosize').length){
        autosize($('.autosize'));
	}
}

export default init;